/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { CART_FRAGMENT } from '@/cart/api/graphql/CartFragment';
import { CART_ITEMS_PAGINATION_ARGUMENTS } from '@/cart/api/graphql/arguments';

export const REMOVE_GIFT_CARD_ON_CART_MUTATION = `
  mutation REMOVE_GIFT_CARD_ON_CART_MUTATION($cartId: String!, $giftCardCode: String!, ${CART_ITEMS_PAGINATION_ARGUMENTS}) {
 removeGiftCardFromCart(
    input: {
     cart_id: $cartId
     gift_card_code: $giftCardCode
    }
  ) {
    cart {
      ...CART_FRAGMENT
    }
  }
}
${CART_FRAGMENT}
`;
